

class DateRangePicker{
    defaultOptions() {
        return {
        	'$input': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$input = this.settings.$input;
        if(!this.$input){
        	window.notify('Missing $input parameter for DateRangePicker','error');
        }

        this.initialize();
    }


    initialize(){

    	this.min = this.$input.data('min');

    	this.$input.daterangepicker({
    		"opens": "left",
    		'minDate': this.min,
    		"locale": {
		        "format": "DD/MM/YYYY",
		        "separator": " - ",
		        "applyLabel": "Appliquer",
		        "cancelLabel": "Annuler",
		        "fromLabel": "Du",
		        "toLabel": "Au",
		        "customRangeLabel": "Personnalisé",
		        "weekLabel": "S",
		        "daysOfWeek": [
		            "Di",
		            "Lu",
		            "Ma",
		            "Me",
		            "Je",
		            "Ve",
		            "Sa"
		        ],
		        "monthNames": [
		            "Janvier",
		            "Février",
		            "Mars",
		            "Avril",
		            "Mai",
		            "Juin",
		            "Juillet",
		            "Août",
		            "Septembre",
		            "Octobre",
		            "Novembre",
		            "Decembre"
		        ],
		        "firstDay": 1
		    }
    	});
    }
}

module.exports = DateRangePicker;